const ROLE_LABELS_FI = {
  chairman: "puheenjohtaja",
  selection_delegate: "valintavaltuutettu",
  property_manager: "isännöitsijä",
  designer: "suunnittelija",
  project_manager: "projektipäällikkö",
  board_member: "hallituksen jäsen"
};

export function getRoleLabelFi(role) {
  if (!role) {
    return "";
  }

  return ROLE_LABELS_FI[role] || role.replaceAll("_", " ");
}